module.exports = __webpack_public_path__ + "fonts/InstrumentSans-VariableFont.7d72615.woff2";